import React from 'react'
import warningData from '../../img/icons/general-icons/icon_warning.png'

export default class RiskFactorsComponent extends React.Component {
  textEvaluator (d) {
    let {medicalData} = d.data
    let imc = (medicalData.peso / ((medicalData.altura/100) * (medicalData.altura/100))).toFixed(1)
    let obj = new Map()
    
    let {estadoSaludData} = d
    let sistoleParado = estadoSaludData[0].sistoleParado
    let sistoleSentado = estadoSaludData[0].sistoleSentado
    let diastoleParado = estadoSaludData[0].diastoleParado
    let diastoleSentado = estadoSaludData[0].diastoleSentado
    let fuma = estadoSaludData[0].fuma
    let FC = estadoSaludData[0].frecuencia
    if(sistoleParado > 140){
      obj.set('P. Sistólica Parado', sistoleParado)
    }
    if(sistoleSentado > 140 ){
      obj.set('P. Sistólica Sentado', sistoleSentado)
    }
    if(diastoleParado > 80){
      obj.set('P. Diastólica Parado', diastoleParado)
    } 
    if(diastoleSentado > 80){
      obj.set('P. Diastólica Sentado', diastoleSentado)
    } 
    if(imc < 20 || imc >= 30){
      obj.set('imc',imc)
    }
    if(fuma == 'Si'){
      obj.set('Fuma', 'Si')
    }
    if(FC >=90){
      obj.set('Frecuencia', FC)
    }

    let htmlStr = []
    function html(obj){
      for(let [clave,valor] of obj){
        htmlStr.push(<div className='container-risk' key={`${Math.random()*Math.random()}k`}>
          <span className='label' key={`${Math.random()*Math.random()}k`}>{clave}</span>
          <span className='value' key={`${Math.random()*Math.random()}k`}>{valor} </span>
          <img className='range-warning-image' src={warningData}/>
        </div>)
      }
      return htmlStr
    }
    return ( html(obj) )
  }
  render () {
    let text = this.textEvaluator(this.props.data)
    return (
      <div className='dashboard-medical-container'>
        <div className='header-medical-data'>
          <label>Riesgos</label>
        </div>
        <div className='patient-special-information'>
          <div className='risk-container'>
            {text}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/DashboardRiskFactors.js